import MainLayout from '../layouts/main';
import StoreContainer from './container';

function StorePage() {
  return (
    <MainLayout>
      <StoreContainer />
    </MainLayout>
  );
}

export default StorePage;
